let defaultProfile = 'medium';
export function setDefaultProfile(profile: string) {
  defaultProfile = profile;
}

export function getDefaultProfile() {
  return defaultProfile;
}
